import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core';
import React from 'react';

const UOAFilter = ({ styles, setFilters, getFilters }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Grid
        container
        item
        xs={6}
        spacing={1}
        style={{ alignContent: 'center' }}
      >
        <div style={styles.textContainer}>
          Unusual Options Activity provides insight on where the “smart money”
          is positioning themselves, signaling a potential big move in the
          stock. This Unusual Options Activity Scanner helps you find those
          trades by filtering down to a select group of stocks with the most
          active options. &nbsp;
          <a href="https://optionsgeek.com/tools/unusual-options-activity/">
            Click Here
          </a>{' '}
          to learn more about what each column represents, how to read the
          options scanner, and the #1 problem you’ll face with Unusual Options
          Activity.
        </div>
      </Grid>
      <Grid container item xs={6} spacing={1} className='uoa-card'>
        <Grid item xs={6} >
          <Card style={{ padding: '0px' }}>
            <CardContent style={styles.cardTitle}>
              <Typography
                style={{
                  textAlign: 'center',
                  backgroundColor: '#404040',
                  color: 'white',
                  fontSize: '0.875rem',
                  fontWeight: 'bold',
                }}
              >
                Market Cap
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                style={
                  getFilters('all2')
                    ? styles.activeButton
                    : styles.inactiveButton
                }
                onClick={() => setFilters('all2')}
                size="small"
              >
                All
              </Button>
              <Button
                style={
                  getFilters('Small')
                    ? styles.activeButton
                    : styles.inactiveButton
                }
                onClick={() => setFilters('Small')}
                size="small"
              >
                Small
              </Button>
              <Button
                style={
                  getFilters('Mid')
                    ? styles.activeButton
                    : styles.inactiveButton
                }
                onClick={() => setFilters('Mid')}
                size="small"
              >
                Mid
              </Button>
              <Button
                style={
                  getFilters('Large')
                    ? styles.activeButton
                    : styles.inactiveButton
                }
                onClick={() => setFilters('Large')}
                size="small"
              >
                Large
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid item xs={6} >
          <Card >
            <CardContent style={styles.cardTitle}>
              <Typography
                style={{
                  textAlign: 'center',
                  backgroundColor: '#404040',
                  color: 'white',
                  fontSize: '0.875rem',
                  fontWeight: 'bold',
                }}
              >
                Implied Volatility
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                style={
                  getFilters('all3')
                    ? styles.activeButton
                    : styles.inactiveButton
                }
                onClick={() => setFilters('all3')}
                size="small"
              >
                All
              </Button>
              <Button
                style={
                  getFilters('IVUP')
                    ? styles.activeButton
                    : styles.inactiveButton
                }
                onClick={() => setFilters('IVUP')}
                size="small"
              >
                IV Up
              </Button>
              <Button
                style={
                  getFilters('IVDOWN')
                    ? styles.activeButton
                    : styles.inactiveButton
                }
                onClick={() => setFilters('IVDOWN')}
                size="small"
              >
                IV Down
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default UOAFilter;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/UOAFilters.jsx